/* istanbul ignore file */
import { applicationError, updateLocale } from '@americanexpress/one-app-ducks';
import getNavLocale from './components/MarketSpecificNavLocale';

// For loading JSON properties, update the lower case locale (en-us) to upper case locale(en-US).
export default function updateLocaleFromRoute({ dispatch }) {
  return async (nextState, replace, callback) => {
    const { params: { locale } } = nextState;
    // eslint-disable-next-line no-console
    console.log('locale detail', locale);
    try {
      if (!locale) {
        throw new Error('Locale was not supplied as a route parameter');
      }

      const formattedLocale = locale.replace(
        /-([a-z]{2})/i,
        (match, group) => `-${group.toUpperCase()}`
      );
      // eslint-disable-next-line no-console
      console.log('formattedLocale', formattedLocale);
      await dispatch(updateLocale(getNavLocale(formattedLocale)));
    } catch (error) {
      dispatch(applicationError(
        '500',
        /* istanbul ignore next */
        error instanceof Error ? error : new Error(error),
        {
          moduleID: 'axp-maps-travelers-cheques-root',
        }
      ));
      /* istanbul ignore next */
      if (window.location.pathname.indexOf('/error') === -1) {
        replace(`${window.location.pathname}/error/404`);
      }
    }

    return callback();
  };
}
